<template>
  <v-app>
    <school-core-app-bar v-model="expandOnHover" />

    <school-core-drawer :expand-on-hover.sync="expandOnHover" />

    <school-core-view />

     <!--dashboard-core-settings v-model="expandOnHover" /-->
  </v-app>
</template>

<script>
  export default {
    name: 'SchoolIndex',

    components: {
      SchoolCoreAppBar: () => import('./components/core/AppBar'),
      SchoolCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      SchoolCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
